import Component from './LoginFormPasswordContainer'

export default Component
